import Cookies from 'js-cookie';
import { getRootDomain } from '@/utils/common';
import snq from 'snq';

const SPORTSBOOK_PATHS = ['/sports'];
const CASINO_PATHS = ['/casino'];

export const LAST_VISITED_PAGE = 'LAST_VISITED_PAGE';
export const LAST_VISITED_PAGE_EXPIRE = 90;
export const PAGES = {
  SPORTSBOOK: 's',
  CASINO: 'c',
};

export const setToCookie = page =>
  Cookies.set(LAST_VISITED_PAGE, page, {
    expires: LAST_VISITED_PAGE_EXPIRE,
    domain: getRootDomain(location.hostname),
  });

export const setLastVisit = route => {
  if (route.fullPath === '/') {
    return;
  }

  if (route && snq(() => SPORTSBOOK_PATHS.find(path => route && route.fullPath.startsWith(path)))) {
    setToCookie(PAGES.SPORTSBOOK);
  } else if (route && snq(() => CASINO_PATHS.find(path => route && route.fullPath.startsWith(path)))) {
    setToCookie(PAGES.CASINO);
  } else {
    setToCookie('');
  }
};

export const redirectToLastVisitedPage = (route, router) => {
  const lastVisitedPage = Cookies.get(LAST_VISITED_PAGE);
  const isSportsBook = snq(() => route.matched[0].name.includes('sports'));
  const isCasino = snq(() => route.matched[0].name.includes('casino'));

  if (lastVisitedPage === PAGES.SPORTSBOOK && !isSportsBook) {
    Cookies.set(LAST_VISITED_PAGE, '');
    router.push('/sports');
  } else if (lastVisitedPage === PAGES.CASINO && !isCasino) {
    Cookies.set(LAST_VISITED_PAGE, '');
    router.push('/casino');
  } else {
    router.push('/sports');
  }
};
